module.exports = __webpack_public_path__ + "bfe9e51331d30173bc0d1a7010040be9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chipotle_2021_chart.png
// module id = 1651
// module chunks = 0